module.exports = __webpack_public_path__ + "images/ebooks/multi-device-elearning-6fc0cd8cde12cfdb56d91aa9e722c35a.webp";